import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const InputField = forwardRef(function InputField({ label, error, className = "", ...props }, ref) {
  return (
    <label className="block text-left">
      {label ? <span className="mb-1.5 block text-sm font-semibold text-brand-ink">{label}</span> : null}
      <input
        ref={ref}
        className={cn(
          // WHY text-base on mobile: iOS Safari zooms the page on focus when
          // an input is under 16px; sm:text-sm keeps the desktop look.
          "w-full rounded-xl border bg-white px-4 py-2.5 text-base text-brand-ink outline-none transition placeholder:text-slate-400 focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 sm:text-sm",
          // Required/invalid fields turn red so a missing field is unmistakable.
          error ? "border-red-500 focus:border-red-500 focus:ring-red-500/20" : "border-slate-200",
          className
        )}
        {...props}
      />
      {error ? <span className="mt-1 block text-xs font-semibold text-red-600">{error}</span> : null}
    </label>
  );
});

export default InputField;
